import { keyframes } from 'styled-components';

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

/**
 * Color change animation styles
 * @param {object} data settings for color change
 * @returns {string} CSS for animation
 */
export const colorWithHover = ({ color, inverse, borderWidth }) => `
  color: ${color};  
  border: ${borderWidth} solid ${color};
  -webkit-transition : color 100ms linear; 
  -moz-transition : color 100ms linear;
  -o-transition : color 100ms linear;
  -webkit-transition : background-color 100ms linear; 
  -moz-transition : background-color 100ms linear;
  -o-transition : background-color 100ms linear;

  &:hover {
    background-color: ${color};
    color: ${inverse};
  }
`;

// /**
//  * Parallax scroll calculator
//  * @param {int} imageHeight of image
//  */
// export const parallax = (currentOffset) => {

// };



// WEBPACK FOOTER //
// ./src/utils/animations.js